import merge from 'lodash/merge'
// import { itemCommonUtilis } from 'item-component'
import { envExternalConfigs } from './apiConfigExternal'
import {
  isPartnerOnline,
  LoginRedirectPath,
  findAppPath,
  isItemhubDomain,
} from '../globalUtils/searchUtills'

const apiKey = '8d3b2848ce5f16aac9016898d5d5721cc47fb81e'
const apiKeyProduction = 'd538fd2dc47b9df208428854cc991f6646ae3350'
const { location } = window
const itemHubPath = isItemhubDomain ? '/launchpad' : ''
const commonConfig = {
  auth: {
    authorizationUrl:
      'https://oauth.iam.perf.target.com/auth/oauth/v2/authorize',
    logoutUrl:
      'https://logonservices.iam.perf.target.com/login/responses/logoff.html',
    storageType: 'localStorage',
  },
  analytics: {
    appName: 'LP_SEARCH',
    url: 'https://stgapi-internal.target.com/firefly_internal_events/v1',
    retries: 1,
    apiKey: apiKey,
  },
}

const envConfigs = {
  // dev is the default development environment set by .env.development and the default pipeline in .vela.yml
  local: {
    auth: {
      clientId: 'launchpad_npe_im',
      loginRedirect: `${location.origin}/auth/login`,
    },
    apiKey,
    graphql: {
      uri: 'https://stgapi-internal.target.com/graphql_launchpad/v1',
    },
    debug: {
      enableReduxDevTools: true,
      enableNetworkLogging: true,
      networkOptions: {
        /* WARNING: Memory intensive! Only enable for testing or severe bugs. */
        body: true,
      },
    },
    pipeline: {
      baseUrl: 'https://pipeline.perf.target.com/v2/',
      detailsPath: 'images/search/?navigationAction=manageImages&tcins=',
    },
    launchpad: {
      host: 'http://localhost:3000',
      page: {
        dashboard: '/taskboard',
        maintain: '/maintain',
        create: '/create',
        bulk: '/bulk',
        admin: '/admin',
        relationship: '/relationship',
        iau: '/item-attribute-update-request',
      },
    },
    massMaintain: {
      host: 'https://uimititem.dev.target.com',
    },
    groups: {
      host: 'https://grouperui.dev.target.com',
    },
    opentask: {
      host: 'http://localhost:3000/mytasks/',
    },
    support: {
      host: `https://targetprod.service-now.com/merch_support`,
    },
    casePack: {
      host: ' https://casepackui.dev.target.com',
      managePath: '/casepack/manage/',
    },
    presentationAttribute: {
      host: 'https://presentationattributesui.dev.target.com',
      managePath: '/maintain',
    },
    itemVop: {
      host: 'https://itemvopui.dev.target.com',
      managePath: '/itemvop/manage/',
    },
    remotes: {
      //  search: 'veSearch@//localhost:3000',
      search: 'veSearch@//veitemsearch.dev.target.com',
      // bulk: 'veItemBulk@//localhost:3000',
      bulk: 'veItemBulk@//veitembulk.dev.target.com',
      // bulkX: 'veItemBulk@//localhost:3000',
      bulkX: 'veItemBulk@//veitembulk-itemx.dev.target.com',
      // iau: 'veIau@//localhost:3000',
      iau: 'veIau@//veiau.dev.target.com',
    },
    itemhubappservice: {
      apiKey: '9b270afab4c57b904c9e56c37ad03dc7f82936ac',
    },
  },
  ephemeral: {
    auth: {
      clientId: 'launchpad_npe_im',
      loginRedirect: LoginRedirectPath(),
    },
    apiKey,
    graphql: {
      uri: 'https://stgapi-internal.target.com/graphql_launchpad/v1',
    },
    debug: {
      enableReduxDevTools: true,
      enableNetworkLogging: true,
      networkOptions: {
        /* WARNING: Memory intensive! Only enable for testing or severe bugs. */
        body: true,
      },
    },
    pipeline: {
      baseUrl: 'https://pipeline.perf.target.com/v2/',
      detailsPath: 'images/search/?navigationAction=manageImages&tcins=',
    },
    launchpad: {
      host: 'https://xycpre-launchpad.target.com/v2',
      page: {
        dashboard: '/',
        maintain: '/maintain',
        create: '/create',
        bulk: '/bulk',
        admin: '/admin',
        iau: '/item-attribute-update-request',
      },
    },
    massMaintain: {
      host: 'https://uimititem.dev.target.com',
    },
    groups: {
      host: 'https://grouperui.dev.target.com',
    },
    opentask: {
      host: `${findAppPath()}/mytasks/`,
    },
    itemhubappservice: {
      apiKey: '9b270afab4c57b904c9e56c37ad03dc7f82936ac',
    },
  },
  dev: {
    auth: {
      clientId: 'launchpad_npe_im',
      loginRedirect: LoginRedirectPath(),
    },
    apiKey,
    graphql: {
      uri: 'https://stgapi-internal.target.com/graphql_launchpad/v1',
    },
    debug: {
      enableReduxDevTools: true,
      enableNetworkLogging: true,
      networkOptions: {
        /* WARNING: Memory intensive! Only enable for testing or severe bugs. */
        body: true,
      },
    },
    pipeline: {
      baseUrl: 'https://pipeline.perf.target.com/v2/',
      detailsPath: 'images/search/?navigationAction=manageImages&tcins=',
    },
    launchpad: {
      // host: 'https://xycpre-launchpad.target.com/v2',
      host: `${findAppPath()}/v2`,
      page: {
        dashboard: '/taskboard',
        maintain: '/maintain',
        create: '/create',
        bulk: '/bulk',
        admin: '/admin',
        iau: '/item-attribute-update-request',
      },
    },
    massMaintain: {
      host: 'https://uimititem.dev.target.com',
    },
    groups: {
      host: 'https://grouperui.dev.target.com',
    },
    opentask: {
      host: `${findAppPath()}/mytasks/`,
    },
    support: {
      host: `https://targetprod.service-now.com/merch_support`,
    },
    casePack: {
      host: ' https://casepackui.dev.target.com',
      managePath: '/casepack/manage/',
    },
    presentationAttribute: {
      host: 'https://presentationattributesui.dev.target.com',
      domainPath: '/presentation-attributes',
      managePath: '/maintain',
    },
    itemVop: {
      host: 'https://itemvopui.dev.target.com',
      managePath: '/itemvop/manage/',
    },
    remotes: {
      search: `veSearch@//${location.hostname}${itemHubPath}/assets/search`,
      bulk: `veItemBulk@//${location.hostname}${itemHubPath}/assets/bulk`,
      bulkX: `veItemBulk@//${location.hostname}${itemHubPath}/assets/bulkX`,
      iau: `veIau@//${location.hostname}${itemHubPath}/assets/iau`,
    },
    itemhubappservice: {
      apiKey: '9b270afab4c57b904c9e56c37ad03dc7f82936ac',
    },
  },
  stg: {
    auth: {
      clientId: 'launchpad_npe_im',
      loginRedirect: LoginRedirectPath(),
    },
    apiKey,
    graphql: {
      uri: 'https://stgapi-internal.target.com/graphql_launchpad/v1',
    },
    debug: {
      enableReduxDevTools: true,
      enableNetworkLogging: true,
      networkOptions: {
        /* WARNING: Memory intensive! Only enable for testing or severe bugs. */
        body: false,
      },
    },
    pipeline: {
      baseUrl: 'https://pipeline.perf.target.com/v2/',
      detailsPath: 'images/search/?navigationAction=manageImages&tcins=',
    },
    launchpad: {
      // host: 'https://xycpre-launchpad.target.com/v2',
      host: `${findAppPath()}/v2`,
      page: {
        dashboard: '/taskboard',
        maintain: '/maintain',
        create: '/create',
        bulk: '/bulk',
        admin: '/admin',
        iau: '/item-attribute-update-request',
      },
    },
    massMaintain: {
      host: 'https://uimititem.dev.target.com',
    },
    groups: {
      host: 'https://grouperui.dev.target.com',
    },
    opentask: {
      host: `${findAppPath()}/mytasks/`,
    },
    support: {
      host: `https://targetprod.service-now.com/merch_support`,
    },
    casePack: {
      host: ' https://casepackui.dev.target.com',
      managePath: '/casepack/manage/',
    },
    presentationAttribute: {
      host: 'https://presentationattributesui.dev.target.com',
      domainPath: '/presentation-attributes',
      managePath: '/maintain',
    },
    itemVop: {
      host: 'https://itemvopui.dev.target.com',
      managePath: '/itemvop/manage/',
    },
    remotes: {
      search: `veSearch@//${location.hostname}${itemHubPath}/assets/search`,
      bulk: `veItemBulk@//${location.hostname}${itemHubPath}/assets/bulk`,
      bulkX: `veItemBulk@//${location.hostname}${itemHubPath}/assets/bulkX`,
      iau: `veIau@//${location.hostname}${itemHubPath}/assets/iau`,
    },
    itemhubappservice: {
      apiKey: '9b270afab4c57b904c9e56c37ad03dc7f82936ac',
    },
  },
  prod: {
    auth: {
      authorizationUrl: 'https://oauth.iam.target.com/auth/oauth/v2/authorize',
      logoutUrl:
        'https://logonservices.iam.target.com/login/responses/logoff.html',
      clientId: 'launchpad_prod_im',
      loginRedirect: LoginRedirectPath(),
    },
    apiKey: apiKeyProduction,
    analytics: {
      appName: 'LP_SEARCH',
      url: 'https://api-internal.target.com/firefly_internal_events/v1',
      apiKey: apiKeyProduction,
    },
    graphql: {
      uri: 'https://api-internal.target.com/graphql_launchpad/v1',
    },
    debug: {
      enableReduxDevTools: true,
      enableNetworkLogging: false,
      networkOptions: {
        /* WARNING: Memory intensive! Only enable for testing or severe bugs. */
        body: false,
      },
    },
    pipeline: {
      baseUrl: 'https://pipeline.target.com/v2/',
      detailsPath: 'images/search/?navigationAction=manageImages&tcins=',
    },
    launchpad: {
      // host: 'https://launchpad.target.com/v2',
      host: `${findAppPath()}/v2`,
      page: {
        dashboard: '/taskboard',
        maintain: '/maintain',
        create: '/create',
        bulk: '/bulk',
        admin: '/admin',
        iau: '/item-attribute-update-request',
      },
    },
    massMaintain: {
      host: 'https://uimititem-prod.prod.target.com',
    },
    groups: {
      host: 'https://grouperui.prod.target.com',
    },
    opentask: {
      host: `${findAppPath()}/mytasks/`,
    },
    support: {
      host: `https://targetprod.service-now.com/merch_support`,
    },
    casePack: {
      host: ' https://casepackui.prod.target.com',
      managePath: '/casepack/manage/',
    },
    presentationAttribute: {
      host: 'https://presentationattributesui.prod.target.com',
      domainPath: '/presentation-attributes',
      managePath: '/maintain',
    },
    itemVop: {
      host: 'https://itemvopui.prod.target.com',
      managePath: '/itemvop/manage/',
    },
    remotes: {
      search: `veSearch@//${location.hostname}${itemHubPath}/assets/search`,
      bulk: `veItemBulk@//${location.hostname}${itemHubPath}/assets/bulk`,
      bulkX: `veItemBulk@//${location.hostname}${itemHubPath}/assets/bulkX`,
      iau: `veIau@//${location.hostname}${itemHubPath}/assets/iau`,
    },
    itemhubappservice: {
      apiKey: '140fe39560f94052ce0889d2a4eb49fe1666e779',
    },
  },
}

const appEnv = process.env.REACT_APP_ENV
const config = envConfigs[appEnv]

// commonConfig and the config for the matching REACT_APP_ENV are combined.
// Values in the environment-specific config will overwrite commonConfig keys
// if they share the same name.
let apiConfig = merge(commonConfig, config)
if (isPartnerOnline()) {
  apiConfig = merge({}, apiConfig, envExternalConfigs[appEnv])
}

export default apiConfig
